var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2362_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00529 12C7.5347 12 8.9321 11.425 9.9935 10.4802L5.75665 6.24337C5.69071 6.17743 5.65364 6.08799 5.65364 5.99474V0C2.50538 0.182714 0 2.80147 0 5.99471C0 9.30604 2.69398 12 6.00529 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85425 6.34636L10.4908 9.98293C11.3627 9.00347 11.9193 7.73781 12 6.34636H6.85425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35693 5.64308H12C11.824 2.61121 9.38877 0.17597 6.35693 7.62939e-06V5.64308Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2362_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.606d61df82571ed0b3d71dae4dbf9744.svg";
export { ForwardRef as ReactComponent };